import React from 'react';
import { Button } from './ui/button';

function ReportExportButton({ onExport, disabled = false, exporting = false }) {
    return (
        <Button
            type="button"
            variant="outline"
            onClick={onExport}
            disabled={disabled || exporting}
            className="shrink-0"
        >
            {exporting ? 'Exportando…' : 'Exportar CSV'}
        </Button>
    );
}

/** Configuração para PageHeader `actions` (bloco Saída dos relatórios). */
export function toReportExportAction({ onExport, disabled = false, exporting = false }) {
    return {
        label: exporting ? 'Exportando…' : 'Exportar CSV',
        icon: 'export',
        variant: 'outline',
        onClick: onExport,
        disabled: disabled || exporting,
        className: 'shrink-0',
    };
}

export default ReportExportButton;
